import React from 'react';
import Postcode from '@marmalade/form/lib/questions/postcode';

function BrokerPostcode({ ...rest }) {
    return <Postcode label="What is the young driver's postcode?" {...rest} />;
}

export default BrokerPostcode;
